/* eslint-disable @typescript-eslint/no-explicit-any */
import api from '@/api';

import { API_BASE_URL } from '..';
import { SendOptionType } from '../SendOptions/SendOptions.types';

import { Tags } from './EmailTags.types';

const controller = 'email-tags';
const baseUrl = `${API_BASE_URL}/${controller}`;

export async function emailTagsByType(type?: SendOptionType) {
  const result = (await api.get(`${baseUrl}/${type}`, {})) as unknown;

  return result as Tags[];
}
